var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import cl from 'clsx';
import React, { forwardRef } from 'react';
const Heading = forwardRef((_a, ref) => {
    var { level = '1', size = 'medium', spacing = false, className, as } = _a, rest = __rest(_a, ["level", "size", "spacing", "className", "as"]);
    const HeadingTag = as !== null && as !== void 0 ? as : `h${level}`;
    return (React.createElement(HeadingTag, Object.assign({}, rest, { ref: ref, className: cl(className, 'cds-heading', `cds-heading--${size}`, {
            'cds-typo--spacing': spacing
        }) })));
});
Heading.displayName = 'Heading';
export default Heading;
